import { render, staticRenderFns } from "./Challenge10.vue?vue&type=template&id=5c0fab52&scoped=true&lang=pug&"
import script from "./Challenge10.vue?vue&type=script&lang=ts&"
export * from "./Challenge10.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fab52",
  null
  
)

export default component.exports